import { Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import Chart from "react-google-charts";
import { useAllMatches } from "../../hooks";
import { MatchFilter } from "../../libs/statsFilters";
import { GlobalStatsSelection } from "../../types/stats";

export function CityEscapeCalendarChart({
  selection,
  filters,
  pending,
}: {
  selection?: GlobalStatsSelection & { enigmaId?: string };
  filters?: MatchFilter;
  pending?: boolean;
}) {
  const matches = useAllMatches({ selection, filters }, { enabled: !pending });

  const matchesByDate = useMemo(() => {
    const matchesMap: Record<string, number> = {};
    if (matches.data) {
      matches.data.forEach?.((match) => {
        if (!match.date_created) return;
        const dateKey = match.date_created?.split("T")[0];
        if (matchesMap[dateKey]) {
          matchesMap[dateKey] += 1;
        } else {
          matchesMap[dateKey] = 1;
        }
      });
    }
    return matchesMap;
  }, [matches.data]);

  const data = useMemo(() => {
    return [
      [
        { type: "date", label: "Data" },
        { type: "number", label: "Partite giocate" },
      ],
      ...Object.entries(matchesByDate).map(([date, count]) => [
        new Date(date),
        count,
      ]),
    ];
  }, [matchesByDate]);

  const includedYears = useMemo(() => {
    const yearsSet = new Set<number>();
    for (const dateStr of Object.keys(matchesByDate)) {
      const year = new Date(dateStr).getFullYear();
      yearsSet.add(year);
    }
    return Array.from(yearsSet).sort();
  }, [matchesByDate]);

  const options = useMemo(() => {
    return  {
      width: 1000,
      height: 165 * (includedYears.length || 1),
    };
  }, [includedYears]);



  return (
    <Stack direction="column">
      <Typography variant="h6" gutterBottom>
        Partite giocate nel tempo
      </Typography>
      <Chart
        chartType="Calendar"
        data={data}
        options={options}
        style={{ margin: "0 auto" }}
      />
    </Stack>
  );
}
